import Actions from './parts/Actions'
import Content from './parts/Content'
import { Printer } from '@/features/print/types'
import Item from '@/features/settings/components/PrintManagement/components/Item'
import { PrinterActions } from '@/features/settings/components/PrintManagement/types'
import { FC } from 'react'

type PrinterItemProps = {
    printer: Printer
} & PrinterActions

const PrinterItem: FC<PrinterItemProps> = ({ printer, onEditPrinter, onDeletePrinter }) => {
    return (
        <Item>
            <Content printerName={printer.name} printTypes={printer.printTypes} />
            <Actions
                printerId={printer.id}
                onEditPrinter={onEditPrinter}
                onDeletePrinter={onDeletePrinter}
            />
        </Item>
    )
}

export default PrinterItem
